// Animation
gsap.registerPlugin(ScrollTrigger);

$(document).ready(function() {
 gsap.to('.diamondHighlight-content', {scrollTrigger: {trigger: ".diamond-design",start: "top center", scrub: 1}, y: -30})

 gsap.to('.ringBox-wrapper', {scrollTrigger: {trigger: ".ringBox-wrapper",start: "bottom bottom", scrub: 3}, transform: 'translate(-50%,-50%) rotate(0deg) scale(.95)'})
 gsap.to('.ringBox-wrapper .rightRing_box', {scrollTrigger: {trigger: ".ringBox-wrapper",start: "bottom bottom", scrub: 1}, transform: 'unset'})

const gsapMediaQuery = window.matchMedia('(max-width: 750px)')
if (gsapMediaQuery.matches) {
 gsap.to('.diamondImg-wrapper > img', {scrollTrigger: {trigger: ".diamond-design",start: "top bottom", scrub: 1}, transform: 'unset'})
}
else {
 gsap.to('.diamondImg-wrapper > img', {scrollTrigger: {trigger: ".diamondHighlight-content",start: "top bottom", scrub: 1}, transform: 'unset'})
}

 gsap.to('.image-with-text.left .image-with-text__imageBefore', {scrollTrigger: {trigger: ".image-with-text.left",start: "top center"}, transform: 'translateY(-50%) scaleX(1)'})
 gsap.to('.image-with-text.right .image-with-text__imageBefore', {scrollTrigger: {trigger: ".image-with-text.right",start: "top center"}, transform: 'translateY(-50%) scaleX(1)'})

 gsap.to('.ced-gallery .animTop', {scrollTrigger: {trigger: ".ced-gallery",start: "top center", scrub: 2}, y: -60})

})